import {action, observable} from "mobx"

class FlagsStore{
  @observable flagships = []
  @action getFlags(){

  }
}
